export default __webpack_public_path__ + "images/homepage_slideshow_down-bc4b730afeb643828d9356767e19a042.svg";